/* eslint-disable no-underscore-dangle */
import { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios';
import { RemoteConfigUtils } from '~/utils/RemoteConfigUtils';

interface IRetryableRequestConfig extends AxiosRequestConfig {
  _retry?: boolean;
  _retryCount?: number;
}

export const attachRetry = (api: AxiosInstance) => {
  api.interceptors.response.use(
    (response) => response,
    async (error: AxiosError) => {
      const originalRequest = error.config as IRetryableRequestConfig;

      if (!originalRequest || !originalRequest?.url) {
        return Promise.reject(error);
      }

      const whitelistedUrls = RemoteConfigUtils.getApiRetryWhitelistedUrls();
      const maxRetryAttempts = RemoteConfigUtils.getApiMaxRetryAttempts() || 0;
      const currentRetryCount = originalRequest._retryCount || 0;

      const shouldRetry =
        whitelistedUrls.some((url) => originalRequest.url!.includes(url)) &&
        currentRetryCount < maxRetryAttempts;

      if (!shouldRetry) {
        // If the request should not be retried, reject immediately
        return Promise.reject(error);
      }

      // If the request should be retried
      console.info(`Retrying request to ${originalRequest.url}, attempt ${currentRetryCount + 1}`);

      // Increment retry count
      originalRequest._retry = true;
      originalRequest._retryCount = currentRetryCount + 1;

      // Wait before retrying
      const delayMs = 200 * originalRequest._retryCount;
      await new Promise((res) => setTimeout(res, delayMs));

      // Retry the request
      return api(originalRequest);
    },
  );
};
